import React, { startTransition, useEffect } from "react";
import styled from "styled-components";
import styles from "./notification.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchNotifications,
  markReadNotifiications,
} from "../../redux/slices/artistSlice";
import { motion, AnimatePresence } from "framer-motion";
import useAuth from "../../hooks/useAuth";

const NotificationList = () => {
  const dispatch = useDispatch();
  const { notifications, isNotificationLoading } = useSelector(
    (state) => state.artists
  );
  let notificationToRender =
    notifications?.length > 0 && !isNotificationLoading
      ? notifications
      : !isNotificationLoading && [];
  useEffect(() => {
    dispatch(fetchNotifications());
    dispatch(markReadNotifiications());
  }, []);

  const { user } = useAuth();

  return (
    <StyledWrapper>
      <div className={styles.parent}>
        <div className="modal">
          <form className="form">
            <motion.span
              className={styles.title}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              {`Notifications for ${user?.username}`}
            </motion.span>
            <div className={styles.all}>
              {notificationToRender?.length === 0 ? (
                <div className={styles.disableText}>
                  {"No notifications to show"}
                </div>
              ) : (
                notificationToRender.map((data, index) => {
                  return (
                    <div
                      className={
                        index % 2 == 0 ? styles.notification : styles.notiNew
                      }
                      key={data.id}
                      style={
                        index < notificationToRender?.length - 1
                          ? {
                              borderBottom: "1px solid gray",
                            }
                          : {}
                      }
                    >
                      <span>{data?.label}</span>
                    </div>
                  );
                })
              )}
            </div>
          </form>
        </div>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .modal {
    width: 300px;
    padding: 16px;
    background: black;
    box-shadow: 0px 187px 75px rgba(0, 0, 0, 0.01),
      0px 105px 63px rgba(0, 0, 0, 0.05), 0px 47px 47px rgba(0, 0, 0, 0.09),
      0px 12px 26px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    border: 1px solid white;
    @media (max-width: 600px) {
      width: 200px;
    }
  }

  .banner {
    width: 100%;
    height: 30px;
    margin: 0;
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .title {
    font-weight: 700;
    font-size: 17px;
    line-height: 21px;
    text-align: center;
    color: #2b2b2f;
    margin-bottom: 15px;
  }

  .description {
    max-width: 80%;
    margin: auto;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: black;
  }

  .tab-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    position: relative;
    padding: 2px;
    background-color: #ebebec;
    border-radius: 9px;
    margin: 10px 20px 0px 20px;
  }

  .indicator {
    content: "";
    width: 50%;
    height: 28px;
    background: #ffffff;
    position: absolute;
    top: 2px;
    left: 2px;
    z-index: 9;
    border: 0.5px solid rgba(0, 0, 0, 0.04);
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.12), 0px 3px 1px rgba(0, 0, 0, 0.04);
    border-radius: 7px;
    transition: all 0.2s ease-out;
  }

  .tab {
    width: 50%;
    height: 28px;
    position: relative;
    z-index: 99;
    background-color: transparent;
    border: 0;
    outline: none;
    flex: none;
    align-self: stretch;
    flex-grow: 1;
    cursor: pointer;
    font-weight: 500;
  }

  .tab--1:hover ~ .indicator {
    left: 2px;
  }

  .tab--2:hover ~ .indicator {
    left: calc(50% - 2px);
  }

  .benefits {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .benefits > span {
    font-size: 15px;
    color: #2b2b2f;
    font-weight: 700;
  }

  .benefits ul {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .benefits ul li {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
  }

  .benefits ul li span {
    font-weight: 600;
    font-size: 12px;
    color: #5f5d6b;
  }

  .modal--footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-top: 1px solid #ebebec;
  }

  .price {
    position: relative;
    font-size: 32px;
    color: #2b2b2f;
    font-weight: 900;
  }

  .price sup {
    font-size: 13px;
  }

  .price sub {
    width: fit-content;
    position: absolute;
    font-size: 11px;
    color: #5f5d6b;
    bottom: 5px;
    display: inline-block;
  }

  .upgrade-btn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 215px;
    height: 40px;
    background: #0bdd12;
    box-shadow: 0px 0.5px 0.5px #efefef, 0px 1px 0.5px rgba(239, 239, 239, 0.5);
    border-radius: 7px;
    border: 0;
    outline: none;
    color: #ffffff;
    font-size: 13px;
    font-weight: 600;
    transition: all 0.3s cubic-bezier(0.15, 0.83, 0.66, 1);
  }

  .upgrade-btn:hover {
    background-color: #07b90d;
  }

  .form {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

export default NotificationList;
